var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ejs-grid',{ref:"modRecordsGrid",attrs:{"dataSource":_vm.modRecords,"columns":_vm.modColumns,"gridLines":"Vertical"},on:{"rowSelected":_vm.modRecordsChanged,"rowDeselected":_vm.modRecordsChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }